import { translate } from "../i18n";
import { Link } from 'react-router-dom';
export default function NotFound() {
  return <main className="sp-not-found"><h1>{translate("Pagina non trovata")}</h1><p>{translate("La pagina richiesta non \xE8 disponibile.")}</p><Link to="/">{translate("Torna alla homepage")}</Link></main>;
}
